// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
  background: #ECEEDF;
  padding: 80px 0;
}
.about-section .section-title {
  color: #111;
  font-size: 40px;
  font-weight: 800;
  margin: 0 0 28px 0;
  padding-bottom: 8px;
  letter-spacing: -0.5px;
}
.about-section .section-title-center {
  text-align: center;
}
.about-section .section-title-left {
  text-align: center;
}
.about-section .about-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin-top: 28px;
  justify-content: center;
}
.about-section .about-text {
  flex: 0 0 68%;
  max-width: 820px;
  text-align: justify;
}
.about-section .about-text p {
  font-size: 16px;
  line-height: 1.9;
  color: #222;
  margin-bottom: 18px;
}
.about-section .about-aside {
  flex: 0 0 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 60px;
  padding-top: 8px;
  max-width: 900px;
  margin: 0 auto;
}
.about-section .about-aside .about-logo {
  width: 120px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(16, 20, 28, 0.08);
}

@media (max-width: 992px) {
  .about-section {
    padding: 60px 0;
  }
  .about-body {
    flex-direction: column;
    align-items: center;
  }
  .about-text {
    flex: 0 0 100%;
    max-width: 720px;
  }
  .about-aside {
    flex: 0 0 auto;
    margin-top: 10px;
    flex-direction: row;
    gap: 15px;
    flex-wrap: wrap;
  }
  .section-title {
    font-size: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/about.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,eAAA;AAFF;AAIE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAFJ;AAKE;EAAwB,kBAAA;AAF1B;AAIE;EAAsB,kBAAA;AADxB;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAII;EACE,eAAA;EACA,gBAAA;EACA,WApCO;EAqCP,mBAAA;AAFN;AAME;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAMI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;AAJN;;AASA;EACE;IAAe,eAAA;EALf;EAMA;IAAY,sBAAA;IAAsB,mBAAA;EAFlC;EAGA;IAAY,cAAA;IAAc,gBAAA;EAC1B;EAAA;IAAa,cAAA;IAAc,gBAAA;IAAgB,mBAAA;IAAmB,SAAA;IAAS,eAAA;EAOvE;EANA;IAAe,eAAA;EASf;AACF","sourcesContent":["$primary-color: #70b60a;\n$text-color: #222;\n\n.about-section {\n  background: #ECEEDF;\n  padding: 80px 0;\n\n  .section-title {\n    color: #111;\n    font-size: 40px;\n    font-weight: 800;\n    margin: 0 0 28px 0;\n    padding-bottom: 8px;\n    letter-spacing: -0.5px;\n  }\n\n  .section-title-center { text-align: center; }\n  \n  .section-title-left { text-align: center; }\n\n  .about-body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 40px;\n    margin-top: 28px;\n    justify-content: center;\n  }\n\n  .about-text {\n    flex: 0 0 68%;\n    max-width: 820px;\n    text-align: justify;\n\n    p {\n      font-size: 16px;\n      line-height: 1.9;\n      color: $text-color;\n      margin-bottom: 18px;\n    }\n  }\n\n  .about-aside{\n    flex: 0 0 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 60px;\n    padding-top: 8px;\n    max-width: 900px;\n    margin: 0 auto;\n\n    .about-logo{\n      width: 120px;\n      height: auto;\n      border-radius: 8px;\n      box-shadow: 0 6px 20px rgba(16,20,28,0.08);\n    }\n  }\n}\n\n@media (max-width: 992px){\n  .about-section{padding:60px 0}\n  .about-body{flex-direction:column;align-items:center}\n  .about-text{flex:0 0 100%;max-width:720px}\n  .about-aside{flex:0 0 auto;margin-top:10px;flex-direction:row;gap:15px;flex-wrap:wrap}\n  .section-title{font-size:32px}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
